/** 品质系统 **/
import Layout from "@/views/layout/Layout";
const qualitySystemRouter = {
  path: "/qualitySystem",
  component: Layout,
  name: "qualitySystem",
  meta: {
    title: "巡检管理",
    icon: "quality",
    roles: ["pinzhixitong"]
  },
  alwaysShow: true,
  children: [
    {
      path: "teamConfig",
      component: () => import("@/views/qualitySystem/teamConfig/index"),
      name: "班组管理",
      meta: {
        title: "班组管理",
        roles: ["banzuguanli"]
      },
      children: []
    },
    {
      path: "workInstruction",
      component: () => import("@/views/qualitySystem/workInstruction/index"),
      meta: {
        title: "作业指导书",
        roles: ["zuoyezhidaoshu"]
      },
      alwaysShow: true,
      children: [
        {
          path: "workItemSetup",
          component: () =>
            import("@/views/qualitySystem/workInstruction/workItemSetup"),
          name: "工作项设置",
          meta: {
            title: "工作项设置",
            roles: ["gongzuoxiangshezhi"]
          },
          children: []
        },
        {
          path: "workScheduleSetup",
          component: () =>
            import("@/views/qualitySystem/workInstruction/workScheduleSetup"),
          name: "作业规程设置",
          meta: {
            title: "作业规程设置",
            roles: ["zuoyeguichengshezhi"]
          },
          children: []
        },
        {
          path: "workFlowTmpl",
          component: () =>
            import("@/views/qualitySystem/workInstruction/workFlowTmpl"),
          name: "作业流程模板",
          meta: {
            title: "作业流程模板",
            roles: ["zuoyeliuchengmoban"]
          },
          children: []
        }
      ]
    },
    {
      path: "projectWorkSetup",
      component: () => import("@/views/qualitySystem/projectWorkSetup/index"),
      meta: {
        title: "项目作业设置",
        roles: ["xiangmuzuoyeshezhi"]
      },
      alwaysShow: true,
      children: [
        {
          path: "workArea",
          component: () =>
            import("@/views/qualitySystem/projectWorkSetup/workArea"),
          name: "作业区域",
          meta: {
            title: "作业区域",
            roles: ["zuoyequyu"]
          },
          children: []
        },
        {
          path: "workFlow",
          component: () =>
            import("@/views/qualitySystem/projectWorkSetup/workFlow/index"),
          name: "作业流程",
          meta: {
            title: "作业流程",
            roles: ["zuoyeliucheng"]
            // keepAlive: true
          },
          children: []
        },
        {
          path: "batchWorkStartstop",
          component: () =>
            import(
              "@/views/qualitySystem/projectWorkSetup/batchWorkStartstop/index"
            ),
          name: "批量任务启停",
          meta: {
            title: "批量任务启停",
            roles: ["piliangrenwuqiting"]
          }
        }
      ]
    },
    {
      path: "projectPerform",
      component: () => import("@/views/qualitySystem/projectPerform/index"),
      meta: {
        title: "项目执行",
        roles: ["xiangmuzhixing"]
      },
      alwaysShow: true,
      children: [
        {
          path: "projectWorkOutline",
          component: () =>
            import("@/views/qualitySystem/projectPerform/projectWorkOutline"),
          name: "项目作业大纲",
          meta: {
            title: "项目作业大纲",
            roles: ["xiangmuzuoyedagang"]
          },
          children: []
        },
        {
          path: "performMan",
          component: () =>
            import("@/views/qualitySystem/projectPerform/performMan"),
          name: "执行管理",
          meta: {
            title: "执行管理",
            roles: ["zhixingguanli"]
          },
          children: []
        },
        {
          path: "taskMan",
          component: () =>
            import("@/views/qualitySystem/projectPerform/taskMan"),
          name: "任务管理",
          meta: {
            title: "任务管理",
            roles: ["renwuguanli"],
            keepAlive: true
          },
          children: []
        }
      ]
    },
 {
      path: "inspectionRectification",
      component: () =>
        import("@/views/qualityControl/inspectionRectification/index"),
      meta: {
        title: "巡检整改",
        roles: ["pzkz_xunjianzhenggai"],
      },
      alwaysShow: true,
      children: [
        {
          path: "rectificationExecution",
          component: () =>
            import(
              "@/views/qualityControl/inspectionRectification/rectificationExecution"
            ),
          name: "整改执行",
          meta: {
            title: "整改执行",
            roles: ["pzkz_xjzg_zhenggaizhixing"],
          },
          children: [],
        },
        {
          path: "rectificationSupervision",
          component: () =>
            import(
              "@/views/qualityControl/inspectionRectification/rectificationSupervision/index"
            ),
          name: "整改管理",
          meta: {
            title: "整改管理",
            roles: ["pzkz_xjzg_zhenggaijianguan"],
          },
          children: [],
        },{
          path: "statisticalAnalysis",
          component: () =>
            import(
              "@/views/qualityControl/inspectionRectification/statisticalAnalysis/index"
            ),
          name: "统计分析",
          meta: {
            title: "统计分析",
            roles: ["pzkz_xjzg_tongjifenxi"],
          },
          children: [],
        },
      ],
    },
    // 周期性工作计划
    {
      path: "CyclePlan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      name: "CyclePlan",
      meta: {
        title: "周期性工作计划",
        roles: ["zqxgzjh_web"]
      },
      alwaysShow: true,
      children: [
        // 1. 基础数据维护
        {
          path: "basic",
          component: () => import("@/views/hrMan/orgPlan/index"),
          meta: {
            title: "基础数据维护",
            roles: ["zqxgzjh_web"]
          },
          children: [
            // 1.1 专业维护
            {
              path: "major",
              component: () => import("@/views/cyclePlan/basic/major"),
              name: "CyclePlanMajor",
              meta: {
                title: "专业维护",
                roles: ["zqxgzjh_zywh_web"]
              }
            },
            // 1.2 工作内容维护
            {
              path: "workContent",
              component: () => import("@/views/cyclePlan/basic/workContent"),
              name: "CyclePlanWorkContent",
              meta: {
                title: "工作内容维护",
                roles: ["zqxgzjh_gznrwh_web"]
              }
            },
            // 1.3 项目负责人维护
            {
              path: "projectManager",
              component: () => import("@/views/cyclePlan/basic/projectManager"),
              name: "CyclePlanProjectManager",
              meta: {
                title: "项目负责人维护",
                roles: ["zqxgzjh_xmfzrwh_web"]
              }
            }
          ]
        },
        // 2. 周期性计划管理（包含创建和审核）
        {
          path: "CyclePlanPlanManagement",
          component: () => import("@/views/hrMan/orgPlan/index"),
          name: "CyclePlanPlanManagement",
          meta: {
            title: "周期性计划管理",
            roles: ["zqxgzjh_web"]
          },
          children: [
            // 2.1 周期性计划创建
            {
              path: "create",
              component: () => import("@/views/cyclePlan/create"),
              name: "CyclePlanCreate",
              meta: {
                title: "周期性计划创建",
                roles: ["zqxgzjh_jhcj_web"]
              }
            },
            // 2.2 周期性计划审核
            {
              path: "CyclePlanAudit",
              component: () => import("@/views/cyclePlan/audit"),
              name: "CyclePlanAudit",
              meta: {
                title: "周期性计划审核",
                roles: ["zqxgzjh_jhsh_web"]
              }
            }
          ]
        },
        // 3. 周期性计划查看
        {
          path: "view",
          component: () => import("@/views/cyclePlan/view"),
          name: "CyclePlanView",
          meta: {
            title: "周期性计划查看",
            roles: ["zqxgzjh_jhck_web"]
          }
        },
        // 4. 周期性计划管理（管理员查看各项目数据）
        {
          path: "manage",
          component: () => import("@/views/cyclePlan/manage"),
          name: "CyclePlanManage",
          meta: {
            title: "周期性计划管理",
            roles: ["zqxgzjh_jhgl_web"]
          }
        },
        // 5. 统计分析
        {
          path: "statistics",
          component: () => import("@/views/cyclePlan/statistics"),
          name: "CyclePlanStatistics",
          meta: {
            title: "统计分析",
            roles: ["zqxgzjh_tjfx_web"]
          }
        }
      ]
    },
    // 报表
    {
      path: "statisticalAnalysis",
      component: () => import("@/views/qualitySystem/statisticalAnalysis"),
      name: "统计分析",
      meta: {
        title: "统计分析",
        roles: ["pinzhifenxi_web"]
      }
    },
    {
      path: "statisticalReports",
      component: () => import("@/views/qualitySystem/statisticalReports"),
      name: "统计报表",
      meta: {
        title: "统计报表",
        roles: ["pinzhitongji_web"]
      }
    }
  ]
};

export default qualitySystemRouter;
